import React from "react";
import styled from "styled-components/macro";
import { Button, Stack } from "@mui/material";
import { Trans } from "react-i18next";
import { useSaleExpiration } from "./subscriptionHooks";
import BlackFridayBackground from "icons/BlackFridayBackground";

const Hero = styled.p`
  background: ${({ theme }) => theme.duo.color.red};
  color: ${({ theme }) => theme.duo.color.white};
  font-size: 36px;
  margin: 0;
  font-weight: bold;
  padding: 0 5px;
  border-radius: 3px;
`;

const OfferTop = styled.div`
  width: 100%;
  height: 50%;
  overflow: hidden;
  position: relative;
`;
const OfferBottom = styled.div`
  height: 50%;
  padding: 0px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;
const ExpirationTitle = styled.h2`
  font-size: 22px;
  font-weight: bold;
`;

const OfferWrap = styled.div`
  background-color: #fff;
  margin: -45px -15px -17px;
  width: 290px;
  height: 360px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`;

const BgWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const BlackFridayTitle = styled.h2`
  font-size: 30px;
  font-family: "Noto Sans", "Segoe UI", sans-serif;
  color: transparent;
  font-weight: bold;
  -webkit-text-stroke: 1px white;
  margin: 0 0 15px;
  text-align: center;
  text-transform: uppercase;
  line-height: 1;
`;

const SStack = styled(Stack)`
  position: relative;
  z-index: 1;
  height: 100%;
`;

type Props = {
  onClose: () => void;
};

const SaleDialogBlackFriday: React.FC<Props> = ({ onClose }) => {
  const { saleDiscount, saleTitle } = useSaleExpiration();

  return (
    <OfferWrap>
      <OfferTop>
        <BgWrap>
          <BlackFridayBackground type="small" />
        </BgWrap>
        <SStack direction="column" justifyContent="center" alignItems="center" style={{ height: "100%" }}>
          <BlackFridayTitle>{saleTitle}!</BlackFridayTitle>
          <Hero>- {saleDiscount} %</Hero>
        </SStack>
      </OfferTop>
      <OfferBottom>
        <ExpirationTitle>
          <Trans>Expires soon!</Trans>
        </ExpirationTitle>
        <Button color="primary" variant="contained" size="large" onClick={onClose}>
          <Trans>Continue</Trans>
        </Button>
      </OfferBottom>
    </OfferWrap>
  );
};

export default SaleDialogBlackFriday;
